import { ITreePickerChildren, ITreePickerElement } from './../../../../interfaces/tree-picker.interface';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TreePickerSingleDirectionType, TreePickerSingleDirectionEnum } from '../tree-picker-single/tree-picker-single.component';

@Component({
  selector: 'siu-tree-picker-item-expandable',
  templateUrl: './tree-picker-item-expandable.component.html',
  styleUrls: [ './tree-picker-item-expandable.component.scss' ]
})
export class TreePickerItemExpandableComponent implements OnInit {
  @Input() data: ITreePickerChildren;
  @Input() offsetText: number;
  @Input() offsetTextIncrement: number;
  @Input() direction: TreePickerSingleDirectionType;
  @Output('on-add') onAddEvent: EventEmitter<any> = new EventEmitter();
  @Output('on-remove') onRemoveEvent: EventEmitter<any> = new EventEmitter();
  @Input() readonly: boolean = false;
  @Input() sideDirection: 'ltr' | 'rtl' = 'ltr';
  @Input() hideActionButtons: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  ItemDisabled = (nodeDisabled: boolean, itemSelected: boolean) => {
    if (this.direction === TreePickerSingleDirectionEnum.INPUT)
      return nodeDisabled;
    else
      return !itemSelected;
  }

  HasSelectedChildren = (items: ITreePickerElement[]) => {
    return items.filter(x => x.$$node.checked).length > 0;
  }

  /*HasAllSelectedChildren = (items: ITreePickerElement[]) => {
    return items.filter(x => !x.$$node.checked).length == 0;
  }*/

  HandleAddItem = (child) => {
    this.onAddEvent.emit(child);
  }

  HandleRemoveItem = (child) => {
    this.onRemoveEvent.emit(child);
  }

  HandleAddChildren = (items: ITreePickerElement[]) => {
    items.forEach(child => {
      this.onAddEvent.emit(child);
    });
  }

  get showGroupName(): boolean {
    return this.data.groupName && (this.data.items.filter(x => x.$$node.visible !== false).length > 0);
  }

}
